import axios from "axios";
import { baseUrl } from "../../../../boot";
export const PaymentCheckApi = async (formatData) => {
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/payment-integration`, formatData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Payment api :", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching rates:", error.response?.data || error.message);
    return null;
  }
};
